import React, { useState } from 'react';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import { Button, Modal, ModalBody } from '@/ui';
import { CustomPropertiesPreviewProps } from './types';
import { CustomPropertyPane } from '../../../../containers/DefaultLayout/VariablePane';

const CustomPropertiesPreviewButton = ({ values }: CustomPropertiesPreviewProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Button
        color='primary'
        size='sm'
        title='Preview values'
        aria-label='Preview values'
        onClick={(event) => {
          event.stopPropagation();
          setIsOpen(true);
        }}
      >
        <VisibilityOutlined fontSize='small' />
      </Button>
      <Modal isOpen={isOpen} toggle={toggle} size='lg'>
        <ModalBody sx={{ p: 0 }}>
          <CustomPropertyPane values={{ properties: values }} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default CustomPropertiesPreviewButton;
